/* Shared prize transport; the skin supplies its configured prize, copy, status box and auto-code setting. */
(function () {
  'use strict';
  var D = document;
  function statusRow(text) {
    var d = D.createElement('div');
    d.className = 'dn5w__srow';
    d.innerHTML = '<i></i><span></span>';
    d.querySelector('span').textContent = text;
    return d;
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  function pick(PRIZES) {
    var total = PRIZES.reduce(function (a, p) { return a + Math.max(0, Number(p.weight) || 0); }, 0);
    if (total <= 0) return -1;
    var r = Math.random() * total;
    for (var i = 0; i < PRIZES.length; i++) {
      var weight = Math.max(0, Number(PRIZES[i].weight) || 0);
      if (!weight) continue;
      r -= weight;
      if (r < 0) return i;
    }
    return PRIZES.findIndex(function (p) { return (Number(p.weight) || 0) > 0; });
  }

  var pending = {};
  function put(row, text, ok) {
    row.classList.toggle('is-ok', !!ok);
    row.querySelector('span').textContent = text;
  }
  async function readCart() {
    var r = await fetch(window.dnRoute('cart.js'));
    if (!r.ok) throw new Error('cart read failed');
    return r.json();
  }
  function lines(cart, p) {
    return ((cart && cart.items) || []).filter(function (item) {
      return String(item.id || item.variant_id) === String(p.giftVariant) &&
        String((item.properties || {})._dn5_prize || '') === String(p.code || '1');
    });
  }
  function quantity(items) {
    return items.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
  }
  function free(items) {
    return items.length > 0 && items.every(function (item) { return Number(item.final_line_price) === 0; });
  }
  function codePresent(cart, code) {
    var want = String(code).toLowerCase();
    return [].concat((cart && cart.discount_codes) || [], (cart && cart.cart_level_discount_applications) || [])
      .some(function (d) { return String((d && (d.code || d.title)) || '').toLowerCase() === want && d.applicable !== false; });
  }
  async function restoreGift(p, before) {
    var now = await readCart();
    var oldItems = lines(before, p), nowItems = lines(now, p);
    var oldQuantity = quantity(oldItems);
    if (quantity(nowItems) <= oldQuantity) return true;
    var changed = nowItems.find(function (item) {
      return !oldItems.some(function (old) { return old.key === item.key; });
    }) || nowItems[0];
    var oldLine = oldItems.find(function (item) { return item.key === changed.key; });
    var target = oldLine ? Number(oldLine.quantity || 0) :
      Math.max(0, Number(changed.quantity || 0) - (quantity(nowItems) - oldQuantity));
    var r = await fetch(window.dnRoute('cart/change.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: changed.key, quantity: target })
    });
    if (!r.ok) return false;
    return quantity(lines(await readCart(), p)) === oldQuantity;
  }
  async function transport(p, box, COPY, auto) {
    var giftRow, codeRow, cartChanged = false, codeWasPresent = null, codeNowPresent = false;
    if (p.giftVariant) {
      giftRow = statusRow(fill(COPY.adding, { gift: p.giftName || '' }));
      box.appendChild(giftRow);
    }
    if (p.code) {
      codeRow = statusRow(fill(COPY.applying, { code: p.code }));
      box.appendChild(codeRow);
      if (auto) {
        try {
          codeWasPresent = codePresent(await readCart(), p.code);
          var response = await fetch(window.dnRoute('discount/' + encodeURIComponent(p.code)), { method: 'GET', redirect: 'follow' });
          if (!response.ok) throw new Error('discount request failed');
          var firstCart = await readCart();
          var firstHit = codePresent(firstCart, p.code);
          codeNowPresent = firstHit;
          put(codeRow, fill(firstHit ? COPY.applied : COPY.manual, { code: p.code }), firstHit);
        } catch (e) { put(codeRow, fill(COPY.manual, { code: p.code }), false); }
      } else put(codeRow, fill(COPY.manual, { code: p.code }), false);
    }
    if (giftRow) {
      var before;
      try {
        before = await readCart();
        var oldItems = lines(before, p);
        if (oldItems.length) {
          var alreadyFree = free(oldItems);
          put(giftRow, fill(alreadyFree ? COPY.added : COPY.giftFailed, { gift: p.giftName || '' }), alreadyFree);
        } else {
          var added = await fetch(window.dnRoute('cart/add.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: p.giftVariant, quantity: 1, properties: { _dn5_prize: p.code || '1' } })
          });
          if (!added.ok) throw new Error('gift add failed');
          cartChanged = true;
          if (!free(lines(await readCart(), p))) throw new Error('gift not free');
          put(giftRow, fill(COPY.added, { gift: p.giftName || '' }), true);
        }
      } catch (e) {
        var rollbackConfirmed = true;
        if (cartChanged) {
          try { rollbackConfirmed = await restoreGift(p, before); }
          catch (rollbackError) { rollbackConfirmed = false; }
        }
        put(giftRow, fill(rollbackConfirmed ? COPY.giftFailed : COPY.giftRollbackFailed, { gift: p.giftName || '' }), false);
      }
    }
    /* /discount can redirect successfully without applying a code; the cart is the final source. */
    if (codeRow && auto) {
      try {
        var finalHit = codePresent(await readCart(), p.code);
        codeNowPresent = finalHit;
        put(codeRow, fill(finalHit ? COPY.applied : COPY.manual, { code: p.code }), finalHit);
      } catch (e) { put(codeRow, fill(COPY.manual, { code: p.code }), false); }
    }
    if (cartChanged || (codeWasPresent === false && codeNowPresent)) D.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  function awardTransport(p, box, COPY, auto) {
    var key = String(p.giftVariant || '') + ':' + String(p.code || '');
    if (pending[key]) return pending[key];
    var work = transport(p, box, COPY, auto);
    pending[key] = work;
    work.finally(function () { if (pending[key] === work) delete pending[key]; });
    return work;
  }
  window.dn = window.dn || {};
  window.dn.prize = { pick: pick, award: awardTransport };
})();
